<div class="content">
  <div class="header">
    <label class="headerLabel">Bulk Update SureFlow Unit Details</label>
  </div>
  <div class="inputRow">
    @if (isCooling()) {
      <div class="inputWrapper">
        <div>
          <mat-form-field class="inputField">
            <mat-label class="inputLabel">{{ 'Cooling Total Target (' + getCapacityUnits() + ')' }}</mat-label>
            <input [required]="true" matInput [(ngModel)]="unitData.coolingTargetTotalLoad" type="number"/>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="inputField">
            <mat-label class="inputLabel">{{ 'Cooling Flow Rate for non-SureFlow units (' + getFlowRateUnits() + ')' }}</mat-label>
            <input matInput [(ngModel)]="unitData.coolingFluidFlowRate" type="number"/>
          </mat-form-field>
        </div>
        @if (ratingUnit) {
          <div>
            <mat-form-field class="inputField">
              <mat-label class="inputLabel">{{ 'Cooling Entering Dry Bulb (' + getTemperatureUnits() + ')' }}</mat-label>
              <input matInput [(ngModel)]="coolingEnteringDryBulb" type="number"/>
            </mat-form-field>
          </div>
        }
        @if (ratingUnit) {
          <div>
            <mat-form-field class="inputField">
              <mat-label class="inputLabel">{{ 'Cooling Entering Wet Bulb (' + getTemperatureUnits() + ')' }}</mat-label>
              <input matInput [(ngModel)]="coolingEnteringWetBulb" type="number"/>
            </mat-form-field>
          </div>
        }
      </div>
    }
    @if (isCooling()) {
      <span class="spacer"></span>
    }
    @if (isHeating()) {
      <div class="inputWrapper">
        <div>
          <mat-form-field class="inputField">
            <mat-label class="inputLabel">{{ 'Heating Total Target (' + getCapacityUnits() + ')' }}</mat-label>
            <input [required]="true" matInput [(ngModel)]="unitData.heatingTargetTotalLoad" type="number"/>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="inputField">
            <mat-label class="inputLabel">{{ 'Heating Flow Rate for non-SureFlow units (' + getFlowRateUnits() + ')' }}</mat-label>
            <input matInput [(ngModel)]="unitData.heatingFluidFlowRate" type="number"/>
          </mat-form-field>
        </div>
        @if (ratingUnit) {
          <div>
            <mat-form-field class="inputField">
              <mat-label class="inputLabel">{{ 'Heating Entering Dry Bulb (' + getTemperatureUnits() + ')' }}</mat-label>
              <input matInput [(ngModel)]="heatingEnteringDryBulb" type="number"/>
            </mat-form-field>
          </div>
        }
      </div>
    }
  </div>
  <div class="buttonRow">
    <span class="spacer"></span>
    <button class="dialogButton warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
    <button class="dialogButton primary-button" matButton="elevated" [disabled]="!canSave()" (click)="save()">Save</button>
  </div>
</div>
